import { Box, Button } from "@mui/material";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import { useState } from "react";
import { IconComponent } from "src/shared/components";
import { useGetPartnersDocDeptFilters } from "src/shared/hooks/partnersDocDept/useGetPartnersDocDeptFilters";
import { Can } from "src/shared/lib/rback/Can";
import { EIconNames } from "src/shared/types/iconNames";
import { useLazyExportPartnersDocDeptQuery } from "../api/api";

export function TableHeader() {
  const [exportPartnersDocDept] = useLazyExportPartnersDocDeptQuery();
  const [isExporting, setIsExporting] = useState(false);
  const { query } = useGetPartnersDocDeptFilters();

  const handleExportPartnersDocDept = async () => {
    const nowDate = new Date();
    const exportDate = nowDate.toISOString().slice(0, 10);
    const exportTime = nowDate.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    const FILE_NAME = "Отчет_о_задолженности_клиентов";

    try {
      setIsExporting(true);

      const result = await exportPartnersDocDept(query).unwrap();

      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement("a");
        const resultFileName = `${FILE_NAME}-${exportDate}__${exportTime}`;
        link.href = url;
        link.setAttribute("download", `${resultFileName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      enqueueSnackbar("Произошла ошибка", {
        variant: "error",
        handleClose: closeSnackbar,
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 3,
          ml: "auto",
        }}
      >
        <Can perform="partners.final-report.export">
          <Button
            onClick={handleExportPartnersDocDept}
            startIcon={<IconComponent iconname={EIconNames.DOWNLOAD} />}
            variant="outlined"
            disabled={isExporting}
          >
            Экспорт
          </Button>
        </Can>
      </Box>
    </Box>
  );
}
